import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    error: {
        color: theme.palette.error.main,
    },
}));

export default function ErrorDialog(props) {
    const classes = useStyles();
    const { errorModalOpen, setErrorModalOpen, title, messagePrefix, message } = props;
    return (
        <Dialog
            onClose={() => setErrorModalOpen(false)}
            aria-labelledby="customized-dialog-title"
            open={errorModalOpen}
        >
            <DialogTitle id="customized-dialog-title" onClose={() => setErrorModalOpen(false)}>
                {title}
            </DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>{messagePrefix}</Typography>
                <Typography gutterBottom className={classes.error}>
                    <pre>{message}</pre>
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => setErrorModalOpen(false)}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
